// extracted by mini-css-extract-plugin
export default {"fullWidth":"_m-z","image":"an-z","lazyLoadPicture":"bn-z","lazyLoadSpinner":"cn-z","lazyLoadSpin":"dn-z","lazyLoadImage":"en-z","hasStyledAspectRatio":"fn-z"};